import React, { Fragment, useEffect, useState } from 'react';
import '../My-assessment/myAssessment.scss';
import './gappeoTest.scss';
import { useSelector, useDispatch } from 'react-redux';
import { resetGappeoTest, getGappeoTests, getCategory, getSampleQuestions, resetQuestions, getFilterQuestion } from '../../Redux/ActionCreators/gappeoTestAction';
import { Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Modal, Card } from 'react-bootstrap';
import { getQuestionLevels } from '../../Redux/ActionCreators/testLibraryAction';





export default function GappeoTest() {
    const [page, setPage] = useState(1)
    const [query, setQuery] = useState('');
    const [testType, setTestType] = useState(0);
    const [categoryId, setCategoryId] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [isView, setIsView] = useState(false);
    const [viewDetail, setViewDetail] = useState('');
    const [level, setLevel] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading, categories, gappeoTests, total, languageData, sampleQuestions, loading } = useSelector(state => state.gappeoTest);
    const { questionLevel } = useSelector(state => state.testLibrary);

    const testsPerPage = 10;


    useEffect(() => {
        dispatch(getGappeoTests(0, testType, categoryId, query, currentPage, testsPerPage));
        dispatch(getCategory());
    }, [])

    const timerRef1 = React.useRef();

    const searchTest = (val) => {
        clearTimeout(timerRef1.current);
        setQuery(val);
        setPage(1);
        timerRef1.current = setTimeout(() => delaySearch(val), 800);
    }

    const delaySearch = async (val) => {
        await dispatch(resetGappeoTest());
        await dispatch(getGappeoTests(0, testType, categoryId, val, page, testsPerPage));
    }

    const selectCategory = async (val) => {
        setCategoryId(val);
        setPage(1);
        await dispatch(resetGappeoTest());
        await dispatch(getGappeoTests(0, testType, val, query, 1, testsPerPage));
    }

    const changeType = async (val) => {
        setTestType(val);
        setPage(1);
        setCurrentPage(1)
        await dispatch(resetGappeoTest());
        await dispatch(getGappeoTests(0, val, categoryId, query, 1, testsPerPage));
    }

    const goToSelectTest = (items, type) => {
        console.log(items)
        if (type === 'lang') {
            navigate(`/home/select-test`, {
                state: {
                    detail: items,
                    gappeoTest: true,
                    next: true
                }
            })
        } else {
            navigate(`/home/select-test`, {
                state: {
                    gappeoTest: false,
                    detail: { referenceTypeId: 1, referenceId: items.testID, referenceName: items.testName, testType: testType },
                    next: true
                }
            })
        }
    }

    const openSampleQues = async (data) => {
        setIsOpen(true);
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        dispatch(getQuestionLevels());
        setLevel(0);
        await dispatch(resetQuestions());
        await dispatch(getSampleQuestions(data?.testID, 0, 1, 30));
    }

    const backToMain = () => {
        setIsOpen(false);
    }

    const changeLevel = async (id) => {
        setLevel(id);
        await dispatch(resetQuestions());
        await dispatch(getFilterQuestion(id));
    }

    const viewQuestion = (el) => {
        setIsView(true);
        setViewDetail(el);
    }

    // Pagination logic
    const totalPages = Math.ceil(total / testsPerPage);

    const paginate = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        dispatch(getGappeoTests(0, testType, categoryId, query, pageNumber, testsPerPage));
        };

    const Pagination = ({ currentPage, totalPages, paginate }) => {
        const getPageNumbers = () => {
        if (totalPages <= 4) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        } else if (currentPage <= 3) {
            return [1, 2, 3, "...", totalPages];
        } else if (currentPage >= totalPages - 2) {
            return [1, "...", totalPages - 2, totalPages - 1, totalPages];
        } else {
            return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
        }
        };
    return (
        <div className="pagination">
          <div className="pagination-info">
            {gappeoTests.length > 0 ? (
              <span>
                Showing <strong>{(currentPage - 1) * testsPerPage + 1}</strong>-
                <strong>
                {(currentPage - 1) * testsPerPage + gappeoTests.length}
                </strong>{" "}
                of <strong>{total}</strong>
              </span>
            ) : (
              <span>Showing 0-0 of 0</span>
            )}
          </div>
          <div className="pagination-buttons">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <img src="/images/leftarrow-icon.svg" alt="" />
            </button>
            {getPageNumbers().map((page, index) => (
              <button
                key={index}
                onClick={() => (page === "..." ? null : paginate(page))}
                className={currentPage === page ? "active" : ""}
                disabled={page === "..."}
              >
                {page}
              </button>
            ))}
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
            >
              <img
                src="/images/leftarrow-icon.svg"
                alt=""
                style={{ rotate: "180deg" }}
              />
            </button>
          </div>
        </div>
      );
    }


    return (
        <div className='gappeo-my-tests'>
            {!isOpen ?
                <Fragment>
                    <div className='gappeo-my-tests-head'>
                        <h1>Gappeo Tests</h1>
                        <p className='caption'>Readymade tests that you can use to create custom assessments</p>
                    </div>
                    <div className='search-tests mt-3'>
                        {window.innerWidth < 767 && <p style={{fontFamily:'"Space Grotesk", sans-serif'}}>Test Type : </p>}

                        <div className={window.innerWidth > 767 ? "types-tab overflow-x-auto d-flex align-items-center" : "d-flex align-items-center overflow-auto  mt-2  mb-3"}>

                            {window.innerWidth > 767 && <p style={{fontFamily:'"Space Grotesk", sans-serif'}}>Test Type : </p>}

                            <div className='ps-3' >
                                <div className={testType === 0 ? 'type-btn active-type' : 'type-btn'} onClick={() => changeType(0)}>
                                    <img src={testType === 0 ? '/images/core-pink.svg' : '/images/core.svg'} width={20} alt='' /> &nbsp;MCQ
                                </div>
                            </div>
                            <div className='ps-3'>
                                <div className={testType === 1 ? 'type-btn active-type' : 'type-btn'} onClick={() => changeType(1)}>
                                    <img src={testType === 1 ? '/images/coding-pink.svg' : '/images/coding.svg'} width={20} alt='' /> &nbsp;Coding
                                </div>
                            </div>
                            <div className='ps-3'>
                                <div className={testType === 2 ? 'type-btn active-type' : 'type-btn'} onClick={() => changeType(2)}>
                                    <img src={testType === 2 ? '/images/personality-pink.svg' : '/images/personality.svg'} width={15} alt='' /> &nbsp;Psychometric
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    {isLoading ? 'Loading..' :
                        <div className="table-admin" >
                            <div className='d-flex align-items-center m-3'>
                                <div className="has-search"  >
                                    <span className="form-control-feedback" >
                                        <img src="/images/search.svg" alt='' width={12} />
                                    </span>
                                    <input type="search" className="form-control" value={query} placeholder='Search for test' onChange={(e) => searchTest(e.target.value)} />
                                </div>
                                <div style={{ width: '25%' }}>
                                    <select value={categoryId} onChange={(e) => selectCategory(e.target.value)}>
                                        <option hidden>Test Category</option>
                                        {
                                            categories && categories?.map(el => {
                                                return (
                                                    <option value={el.categoryId}>{el.categoryName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                                {
                                    (testType === 1 ?
                                        <div className='list-skill'>
                                            {languageData?.map((el, i) => {
                                                return (
                                                    <div className='list-skill-item'
                                                        onClick={() => goToSelectTest(el, 'lang')}
                                                    >
                                                        < div className='d-flex flex-column align-items-start ms-3' >
                                                            <h4>{el.displayLanguage}</h4>
                                                            <div className='skill-type' style={{ width: window.innerWidth > 767 ? '' : '75%' }}>
                                                                {<img src='/images/coding-gray.svg' width={12} alt='' />}&nbsp;&nbsp;{'Coding Language'}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <img src='/images/plus-circle.svg' alt='' />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        :
                                        (gappeoTests?.length > 0 ?
                                            <Table responsive className='assessment-table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-left'>Test Name </th>
                                                        <th className='text-left'>Category</th>
                                                        <th className='text-left'>Question Level | Type</th>
                                                        <th className='text-left'>Question | Time</th>
                                                        <th className='text-left'>Sample</th>
                                                        <th className='text-left'>Add</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-body">
                                                    { gappeoTests?.map(el => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        <h4><strong style={{color:'#232529'}}>{el.testName}</strong></h4>
                                                                    </td>
                                                                    <td >
                                                                        <h5>
                                                                            {el.categoryId === 16 ? <img src='/images/cultural-pink.svg' alt='' /> : el.categoryId === 17 ? <img src='/images/behavioural-pink.svg' alt='' /> : el.categoryId === 3 ? <img src='/images/coding-pink.svg' alt='' width={10} /> : el.categoryId === 18 ? <img src='/images/personality-pink.svg' alt='' /> : <img src='/images/core-pink.svg' alt='' />}&nbsp;{el.categoryName}
                                                                        </h5>
                                                                    </td>
                                                                    <td>
                                                                        <h5>
                                                                            {el.testLevelName} | {el.testTypeName}
                                                                        </h5>
                                                                    </td>
                                                                    <td >
                                                                        <h5>
                                                                            {el.questionCount} Qs | {el.duration} Mins
                                                                        </h5>
                                                                    </td>
                                                                    <td className='cursor-pointer'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <button className='create' onClick={() => openSampleQues(el)}>Sample</button>
                                                                        </div>
                                                                    </td>
                                                                    <td className='cursor-pointer'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <button className='create' onClick={() => goToSelectTest(el, 'assessment')}>Add</button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                            :
                                            <div className='empty-list'>
                                                <img src='/images/magnifier.svg' alt='' />
                                                <div className='mt-2'>
                                                    <h3>There is no tests</h3>
                                                </div>
                                            </div>)
                                    )

                                }
                                {testType === 1 ? null :
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        paginate={paginate}
                                    />
                                }
                    </div>
                    }
                </Fragment>
                :
                <Fragment>
                    <div>
                        <div className='d-flex align-items-center' style={{padding:'12px 12px 18px 12px'}}>
                            <img src='/images/back.svg' alt='' className='cursor-pointer' onClick={() => backToMain()} />&nbsp;&nbsp;
                            <h1 className='text-center'>Sample Questions:</h1>&nbsp;
                            <h5 className='text-center' style={{fontFamily:`"Manrope", sans-serif`}}><strong >{sampleQuestions[0]?.skillName}</strong></h5>
                        </div>
                        {/* <p className='caption text-left' style={{color:'#6B7280', fontFamily:`"Space Grotesk", sans-serif`}}>These are only sample questions</p> */}
                        <div className='search-tests'>
                            {window.innerWidth < 767 && <p>Test Level : </p>}
                            <div className={window.innerWidth > 767 ? "types-tab d-flex align-items-center" : "d-flex align-items-center overflow-auto  mt-2  mb-3"}>
                                {window.innerWidth > 767 && <p style={{fontFamily:`"Space Grotesk", sans-serif`}}>Test Level : </p>}
                                <div className='ps-3' style={{cursor:'pointer', fontFamily:`"Space Grotesk", sans-serif`}}>
                                    <div className={Number(level) === 0 ? 'type-btn active-type' : 'type-btn'} style={{width: '45px'}} onClick={() => changeLevel(0)}>
                                        All
                                    </div>
                                </div>
                                {
                                    questionLevel && questionLevel?.map(el => {
                                        return (
                                            <div className='ps-3' style={{cursor:'pointer', fontFamily:`"Space Grotesk", sans-serif`}} >
                                                <div className={Number(level) === Number(el.questionLevelID) ? 'type-btn active-type' : 'type-btn'} style={{width: '45px'}} onClick={() => changeLevel(el.questionLevelID)}>
                                                    {el.questionLevelName}
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className='table-admin'>
                            {loading ? 'Loading..' :
                                sampleQuestions?.length ?
                                    <Table responsive className="tests-table">
                                        <thead>
                                            <tr>
                                                <th className='text-left'><strong>Question</strong></th>
                                                <th className='text-center'><strong>Level</strong></th>
                                                <th className='text-left'><strong>Topic</strong></th>
                                                <th className='text-left'><strong>View</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            {
                                                sampleQuestions && sampleQuestions?.map(el => {
                                                    return (
                                                        <tr>
                                                            <Fragment>
                                                                <td style={{ width: '35%' }}>
                                                                    <h5 className='elipsis-2' style={{color:'#111928'}} dangerouslySetInnerHTML={{ __html: el?.question }} />
                                                                </td>
                                                                <td style={{ width: '16%', textAlign: 'center' }}>
                                                                    <div>
                                                                        <span> {el?.questionLevelName}</span>
                                                                    </div>
                                                                </td>

                                                                <td style={{ width: '30%', textAlign: 'left' }}>
                                                                    <div>
                                                                        {el?.skillTopicName}
                                                                    </div>
                                                                </td>
                                                                <td style={{ width: 50 }}>
                                                                    {/* <img src='/images/view-icon.svg' width={16} className='cursor-pointer' alt='' onClick={() => viewQuestion(el)} /> */}
                                                                    <button className='view-btn' onClick={() => viewQuestion(el)}>View</button>
                                                                </td>
                                                            </Fragment>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table> :
                                    <div className='empty-list'>
                                        <img src='/images/magnifier.svg' alt='' />
                                        <div className='mt-2'>
                                            <h3>No Questions added</h3>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </Fragment>
            }

            <Modal
                show={isView}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"sample-question-modal"}
            >
                <Modal.Header>
                    Sample Questions
                    <div className='sticky-close'>
                        <img src='/images/close-white.svg' alt='' onClick={() => setIsView(false)} />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {loading ? 'Loading..' :
                        <div className='ques-div' >
                            <Card.Header>
                                <div
                                    className='d-flex align-items-center justify-content-between'
                                >
                                    <span dangerouslySetInnerHTML={{ __html: viewDetail?.question }} />

                                </div>
                            </Card.Header>
                            <Card.Body>
                                <ul className='ques-options'>
                                    {
                                        viewDetail?.questionOptions?.map(option => {
                                            return (
                                                <li className={option.iscorrect ? 'correct' : ''}>
                                                    <div>
                                                        {option.questionOption}
                                                    </div>
                                                    {option.iscorrect ? <img src='/images/correct-green.svg' alt='' /> : null}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>

                            </Card.Body>
                        </div>
                    }

                </Modal.Body>

            </Modal>
        </div >
    )
}
